<template>
<div class="chapter">
<div class="inner_page">
<h1 class="copygrey">CONTENTS</h1>
<h2 class="toc"><a href="#/xhtml/03_Abbreviation">Abbreviations</a></h2>
<h2 class="toc"><a href="#/xhtml/04_Intoduction">Introduction</a></h2>
<h2 class="toc1"><a href="#/xhtml/05_Chapter_001"><span class="toc-chap_float">1</span> From Sandino to Sandinistas</a></h2>
<h2 class="toc-han"><span href="#/xhtml/06_Chapter_002" title="Link target outside of Sample"><span class="toc-chap_float">2</span> National Guard versus FSLN forces</span></h2>
<h2 class="toc-han"><span href="#/xhtml/07_Chapter_003" title="Link target outside of Sample"><span class="toc-chap_float">3</span> From Guerrilla War to Insurrection</span></h2>
<h2 class="toc-han"><span href="#/xhtml/08_Chapter_004" title="Link target outside of Sample"><span class="toc-chap_float">4</span> The September 1978 offensive</span></h2>
<h2 class="toc-han"><span href="#/xhtml/09_Chapter_005" title="Link target outside of Sample"><span class="toc-chap_float">5</span> From the Spring Offensive to the General Uprising</span></h2>
<h2 class="toc"><span href="#/xhtml/10_Selectedbibliography" title="Link target outside of Sample">Selected Bibliography</span></h2>
<h2 class="toc"><span href="#/xhtml/11_Notes" title="Link target outside of Sample">Notes</span></h2>
<h2 class="toc"><span href="#/xhtml/12_Acknowledgment" title="Link target outside of Sample">Acknowledgments</span></h2>
<h2 class="toc"><span href="#/xhtml/13_Aouthor" title="Link target outside of Sample">Author</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?1d777110